<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));
let token = user.token;

export default {
  page: {
    title: "Personel Ekle",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Personel Ekle",
      items: [
        {
          text: "RTS",
          href: "/",
        },
        {
          text: "Personel Listesi",
          href: "/employee",
        },
        {
          text: "Personel Ekle",
          active: true,
        },
      ],
      values: {
        name: "",
        citizenship_number: "",
        birtday: "",
        salary: "",
        iban: "",
        status: 1,
        job_start_date: "",
        insurance_start_date: "",
        job_end_date: "",
        job_end_reason: "",
      },
    };
  },
  methods: {
    submitNewHotel() {
      const api_url = process.env.VUE_APP_BASEURL + "/employee";
      axios
        .post(api_url, this.values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          this.$router.push("/employee");
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row justify-content-center">
      <div class="col-12 col-md-9">
        <div class="card mt-4">
          <div class="card-body">
            <form @submit.prevent="submitNewHotel">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label for="name">Personel Adı:</label>
                    <input
                      v-model="values.name"
                      type="text"
                      class="form-control"
                      id="name"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label for="citizenship_number">TCK Numarası:</label>
                    <input
                      v-model="values.citizenship_number"
                      type="number"
                      class="form-control"
                      id="citizenship_number"
                      maxlength="11"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label for="birtday">Doğum Günü Tarihi:</label>
                    <input
                      v-model="values.birtday"
                      type="date"
                      id="birtday"
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label for="salary">Maaş:</label>
                    <input
                      v-model="values.salary"
                      type="text"
                      class="form-control"
                      id="salary"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="iban">IBAN:</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <div class="input-group-text">TR</div>
                    </div>
                    <input
                      v-model="values.iban"
                      type="number"
                      class="form-control"
                      id="iban"
                      maxlength="29"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label for="job_start_date">İşe Başlama Tarihi:</label>
                    <input
                      type="date"
                      v-model="values.job_start_date"
                      id="job_start_date"
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label for="insurance_start_date"
                      >Sıgorta Başlangıç Tarihi:</label>
                    <input
                      type="date"
                      v-model="values.insurance_start_date"
                      id="insurance_start_date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label for="job_end_date">İşten Ayrılma Tarihi:</label>
                    <input
                      type="date"
                      v-model="values.job_end_date"
                      id="job_end_date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group mb-3">
                    <label for="job_end_reason">İşten Ayrılma Sebebi:</label>
                    <textarea
                      v-model="values.job_end_reason"
                      class="form-control"
                      id="job_end_reason"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end align-items-center">
                <button type="submit" class="btn btn-primary px-4">Ekle</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
